@if (isHrefNavigation()) {
    @if (disabled()) {
        <a (click)="$event.stopPropagation()" class="anchor-button__anchor" [class.disabled]="disabled()">
            <ng-container *ngTemplateOutlet="hrefContent"></ng-container>
        </a>
    } @else {
        @if (navigation() === "") {
            <a (click)="onEmptyAnchorClick($event)" class="anchor-button__anchor" [class.disabled]="disabled()">
                <ng-container *ngTemplateOutlet="hrefContent"></ng-container>
            </a>
        } @else {
            <a [href]="navigation()" (click)="$event.stopPropagation()" class="anchor-button__anchor" [class.disabled]="disabled()" target="_blank">
                <ng-container *ngTemplateOutlet="hrefContent"></ng-container>
            </a>
        }
    }
} @else {
    <a (click)="onClick($event)" class="anchor-button__anchor" [class.disabled]="disabled()">
        <ng-container *ngTemplateOutlet="hrefContent"></ng-container>
    </a>
}
<ng-template #hrefContent>
    <ng-content></ng-content>
</ng-template>
